export const isGreaterOrEqualThan = (n) => (value) => {
  if (value && value < n) {
    return `Value should be greater than or equal to ${n}`;
  }
  return undefined;
};

export default isGreaterOrEqualThan;
